/* eslint-disable no-console */
import { useMemo } from "react";

type Props = {
  children?: $TSFixMeFunction;
};

export function ConsoleLogging({ children }: Props) {
  const log = useMemo(
    () => ({
      setUser: () => true,
      error: (context: $TSFixMe, error: $TSFixMe) => {
        console.error(`${context}: ${error?.stack}`);
      },
    }),
    [],
  );

  // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
  return <>{children(log)}</>;
}

export default ConsoleLogging;
